module.exports = __webpack_public_path__ + "img/message.6a1e6912.svg";